export default function parseServerError(errors = []) {
  return errors.reduce(
    (acc, { field, error: err }) => ({ ...acc, [field]: err }),
    {},
  );
}
